define('app/collections/deal_collection',['app/setup','app/models/deal_card'], function(takhfifan, dealCard) {

  takhfifan.DealCardCollection = Backbone.Collection.extend({
    model : takhfifan.DealCard,
    url: function() {
      if(this.type === "search"){
        var urlTemplate = _.template(
          "/catalogsearch/ajax/geocoding?address=<%= address %>&os=<%= os %>"+
          "&form_key=<%= formKey %>&category_ids=<%= categories %>&pageNum=<%= page %>");
        return urlTemplate({
          // order: 'deal_start_date',
          // sortOrder: 'asc',
          // size: 200,
          os: this.section,
          categories: this.categories,
          address: this.address,
          // city: this.city,
          page: this.nextPage,
          formKey: takhfifan.formKey
        })
      }else if(this.type === "latestCoupons"){
        var urlTemplate = _.template("/ajax/productlist/recentProducts?categoryId=<%= categoryId %>");
        return urlTemplate({
          categoryId: this.entityId,
          offset: this.offset,
          limit: this.limit
        });
      }else{
        var urlTemplate = _.template("/ajax/productlist/get/type/<%= type %>/id/<%= id %>/offset/<%= offset %>/page/<%= page %>");
        return urlTemplate({
          type: this.type,
          id: this.entityId,
          offset: this.offset,
          page: this.nextPage
        })
      }
    },

    parse : function(response) {
      if (this.type === "search") {
        return this.parseSearchResults(response)
      }else if(this.type === "latestCoupons"){
        return this.parseCouponsResult(response)
      }else {
        return this.parseResults(response)
      }
    },

    parseSearchResults: function(response) {
      if(!response.pagination || (response.pagination && !response.pagination.totalNumber)){
        this.nextPage = -1;
        return [];
      }

      if(response.pagination.curPage < response.pagination.lastPage){
        this.nextPage = response.pagination.curPage++;
      }else{
        this.nextPage = -1;
      }
      return response.models;
    },

    parseResults:function (response) {
      if(!response.list.length){
        this.nextPage = -1;
      }else{
        this.nextPage++;
      }
      return response.list;
    },

    parseCouponsResult:function (response) {
      if(!response.data.length){
        this.nextPage = -1;
      }else{
        this.nextPage++;
      }
      return response.data;
    }
  });

});

